module.exports = __webpack_public_path__ + "static/media/brand-refresh-back-icon.256d7aa6.svg";